<template>
  <form @submit.prevent="confirmDataStepFpV" >
    <h2 class="mb-4">Bitte überprüfen Sie Ihre Angaben noch einmal genau:</h2>
    <div v-if="previewPerson1">
      <StepTwoForm :disabled="true" :proxyPerson="previewPerson1" />
    </div>
    <div v-if="previewPerson2">
      <h2 class="font-bold mb-4">
        Persönliche Angaben für zweite Person (Gemeinschaftskonto)
      </h2>
      <StepTwoForm :disabled="true" :proxyPerson="previewPerson2" />
    </div>
    <div>
      <h2 class="font-bold mb-4 text-xl">Konto Informationen:</h2>
      <StepThreeForm :disabled="true" :proxyData="$store.state.bankInfo" />
    </div>
    <div v-if="!$store.getters.isGermanAccountCreation">
      <h2 class="font-bold mb-4 text-xl">Fragebogen:</h2>
      <h2
        v-if="previewPerson1"
        class="font-bold bg-gray-400 text-center text-white rounded p-1"
      >
        Angaben für {{ previewPerson1.firstName }}
        {{ previewPerson1.lastName }}:
      </h2>
      <FieldsetsStepFour
        v-if="loaded"
        :disabled="true"
        :proxyFieldset="$store.state.fieldsets"
      />
      <div v-if="previewPerson2">
        <h2 class="font-bold bg-gray-400 text-center text-white rounded p-1">
          Angaben für {{ previewPerson2.firstName }}
          {{ previewPerson2.lastName }}:
        </h2>
        <FieldsetsStepFour
          v-if="loaded"
          :disabled="true"
          :proxyFieldset="$store.state.fieldsets_2"
        />
      </div>
    </div>
    <p class="font-bold mt-4">Alle Daten korrekt eingegeben?</p>
    <div class="flex align-middle items-center">
      <input
        class="checkbox"
        id="check413"
        type="checkbox"
        v-model="isChecked"
        required
        aria-required="true"
      />
      <label class="block text-sm p-4" for="check413">
        Ich erkläre mich mit den
        <a
          class="underline"
          target="_blank"
          href="https://webid-solutions.de/agb/"
          >AGB der WebID Solutions GmbH („WebID“)</a
        >
        einverstanden. Ausführliche Informationen zum Umgang mit Ihren
        personenbezogenen Daten durch WebID können Sie unserer
        <a
          class="underline"
          target="_blank"
          href="https://webid-solutions.de/datenschutzbestimmungen/"
          >Datenschutzerklärung</a
        >
        entnehmen. Wir weisen darauf hin, dass ggf. auch biometrische Daten für
        die
        <a
          class="underline"
          target="_blank"
          href="https://webid-solutions.de/datenschutzbestimmungen/#datenverarbeitung"
          >hier</a
        >
        beschriebenen Zwecke verarbeitet werden.</label
      >
    </div>
<div
  v-if="$route.query.country == 'de'"
  class="flex align-middle items-center"
>
  <input
    class="checkbox"
    id="check414"
    type="checkbox"
    required
    aria-required="true"
  />
  <label class="block text-sm p-4" for="check414">
    Ich erkläre mich mit den
    <a class="underline" target="_blank" href="https://vakifbank.de/de/agb/"
      >AGB</a
    >,
    <a
      class="underline"
      target="_blank"
      href="https://vakifbank.de/de/einlagensicherung/"
      >Einlagensicherung</a
    >,
    <a
      class="underline"
      target="_blank"
      href="https://vakifbank.de/wp-content/uploads/2026/03/Preis-_u_Leistungsverzeichnis.pdf"
      >Preis- und Leistungsverzeichnis</a
    >
    und
    <a
      class="underline"
      target="_blank"
      href="https://vakifbank.de/de/glossar-und-bedingungen/"
      >Besondere Bedingungen</a
    >
    der Vakifbank AG einverstanden.
  </label>
</div>
    <!-- Marketing Opt-in Checkbox -->
    <div
      class="flex align-middle items-center mt-4"
      v-if="$route.query.country === 'at'"
    >
      <input
        class="checkbox"
        id="marketing-opt-in"
        type="checkbox"
        v-model="isMarketingOptedIn"
        @change="submitMarketingOptIn"
      />

      <label class="block text-sm p-4" for="marketing-opt-in">
        Ich möchte von der Bank über exklusive Angebote und wichtige Neuigkeiten
        informiert werden und stimme zu, Marketinginformationen per E-Mail, per
        SMS oder telefonisch zu erhalten. Die Einwilligung kann jederzeit mit
        Wirkung für die Zukunft, auch für einzelne Kommunikationswege,
        widerrufen werden.
      </label>
    </div>

    <!-- Only show this if the country query parameter is 'AT' -->

  <!--  <div v-if="$route.query.country === 'at' && showIdentityProcess"> -->
     <div v-if="$route.query.country === 'at' && false">
      <div class="flex justify-between py-3">
        <button type="button" class="btn btn-grey" @click="$emit('goBack')">
          Zurück
        </button>
        <button v-if="loading" class="btn btn-primary">
          {{ loadingText }} <LoadingCircle />
        </button>

        <button
          type="button"
          class="btn btn-primary"
          @click="openIdentityMethodModal"
          :disabled="!isChecked"
          :class="{ 'opacity-50 cursor-not-allowed': !isChecked }"
        >
          Identitätsmethode wählen
        </button>
      </div>

      <div v-if="showModal" class="modal-overlay">
        <div class="modal-content">
          <h3 class="modal-title">Wählen Sie eine Identitätsmethode:</h3>

          <div class="button-cards">
            <div class="custom-card custom-card-crif">
              <button @click="selectCrifMethod" class="custom-btn">
                <strong>VIDEO IDENTIFIKATION</strong>
              </button>
              <p class="description">
                Bei der Video-Identifikation erfolgt die Identitätsprüfung
                online per Video-Call. Sie benötigen nur eine stabile
                Internetverbindung, eine Kamera und einen amtlichen
                Lichtbildausweis. Ein geschulter Mitarbeiter überprüft Ihre
                Identität in Echtzeit. Dieses Verfahren ist schnell, sicher und
                erspart den Weg in die Filiale.
              </p>
            </div>

            <div v-if="showPostIdent" class="custom-card custom-card-postident">
              <button @click="selectPostIdentityMethod" class="custom-btn">
                <strong>POST IDENTIFIKATION</strong>
              </button>
              <p class="description">
                Die POST-Identifikation ermöglicht die Identitätsprüfung direkt
                an der Haustür durch einen Postbeamten. Ein Mitarbeiter der
                Österreichischen Post überprüft die Identität anhand eines
                amtlichen Lichtbildausweises. Dieses Verfahren ist bequem und
                spart den Gang zur Filiale. Sollte die Identitätsprüfung
                aufgrund Ihrer Abwesenheit nicht erfolgen können, kann sich die
                Bearbeitungszeit entsprechend verlängern.
              </p>
            </div>
          </div>

          <button @click="closeModal" class="custom-btn custom-btn-close">
            Schließen
          </button>
        </div>
      </div>

      <p v-if="!isChecked" class="text-sm text-red-500 mt-2">
        Bitte bestätigen Sie, dass Sie mit den AGB der WebID Solutions GmbH
        einverstanden sind, um fortzufahren.
      </p>
    </div>

<!--    <div
      v-if="
        $route.query.country === 'de' ||
        !$route.query.country ||
        ($route.query.country === 'at' && !showIdentityProcess)
      "
      class="flex justify-between py-3"
    > -->
<div
      v-if="
        $route.query.country === 'de' ||
        !$route.query.country ||
        ($route.query.country === 'at' )
      "
      class="flex justify-between py-3"
    >
      <button type="button" class="btn btn-grey" @click="$emit('goBack')">
        Zurück
      </button>
      <button v-if="loading" class="btn btn-primary">
        {{ loadingText }} <LoadingCircle />
      </button>
      <button v-else class="btn btn-primary">Senden</button>
    </div>
  </form>
</template>

<script>
import FieldsetsStepFour from "./FieldsetsStepFour.vue";
import StepThreeForm from "./StepThreeForm.vue";
import LoadingCircle from "./LoadingCircle.vue";
import StepTwoForm from "./StepTwoForm.vue";
import { toRaw } from "vue";
import axios from "axios";

export default {
  components: {
    FieldsetsStepFour,
    StepThreeForm,
    LoadingCircle,
    StepTwoForm,
  },
  props: {
    guid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      previewPerson2: undefined,
      previewFieldsets: {},
      loaded: false,
      loading: false,
      crifSuccess: false,
      loadingText: "Einen Moment...",
      showModal: false,
      isChecked: false,
      isMarketingOptedIn: false,
      loadingMarketingOptIn: false,
    };
  },
  computed: {
    previewPerson1() {
      return this.$store.state.previewPerson1;
    },
    customerEmail() {
      return this.$store.state.previewPerson1?.email;
    },
    betrag() {
      return this.$store.state.betrag;
    },
    showPostIdent() {
      return this.betrag >= 50000;
    },
    showIdentityProcess() {
      return this.$route.query.country === "at" && this.betrag >= 5000;
    },
  },
  methods: {
    async coolLoadingText() {
      await this.Sleep(7500);
      this.loadingText = "Danke für Ihre Geduld...";

      await this.Sleep(7500);
      this.loadingText = "Fast Fertig...";
    },
    startCrifAuth() {
      this.coolLoadingText();
      return axios
        .get(
          process.env.VUE_APP_BACKEND_DOMAIN + "create-account.php?crif=true",
          {
            headers: {
              Processid: this.guid,
            },
          }
        )
        .then((res) => {
          console.log(res.data);
          this.loadingCRIF = false;
          this.crifSuccess = true;
        })
        .catch((e) => {
          console.log(e);
          this.loadingCRIF = false;
          this.crifSuccess = false;
        });
    },
  async confirmDataStepFpV() {
  if (this.loading) return;
  this.loading = true;

  try {
    await this.startCrifAuth();

    if (this.crifSuccess) {
      try {
        const emailResponse = await axios.post(
          process.env.VUE_APP_BACKEND_DOMAIN +
            "send-confirmation-email.php",
          new URLSearchParams({
            guid: this.guid,
            email: this.customerEmail,
          })
        );

        if (emailResponse.data.status === "success") {
          console.log("Email sent successfully");
        } else {
          console.error("Error sending email:", emailResponse.data.message);
        }
      } catch (emailError) {
        console.error("Error during email sending process:", emailError);
      }

      this.$emit("confirmation");
    }
  } finally {
    this.loading = false;
  }
},
    Sleep(milliseconds) {
      return new Promise((resolve) => setTimeout(resolve, milliseconds));
    },
    openIdentityMethodModal() {
      if (this.isChecked) {
        this.showModal = true;
      }
    },
    // Closes the modal
    closeModal() {
      this.showModal = false;
    },
    selectCrifMethod() {
      this.closeModal();
      this.loading = true;

      // Start CRIF authentication
      this.startCrifAuth()
        .then(() => {
          if (this.crifSuccess) {
            this.$router.push({
              name: "confirmation",
              params: { guid: this.guid },
            });

            axios
              .post(
                process.env.VUE_APP_BACKEND_DOMAIN +
                  "send-confirmation-email.php",
                new URLSearchParams({
                  guid: this.guid,
                  email: this.customerEmail,
                })
              )
              .then((emailResponse) => {
                if (emailResponse.data.status === "success") {
                  console.log("Email sent successfully");
                } else {
                  console.error(
                    "Error sending email:",
                    emailResponse.data.message
                  );
                }
              })
              .catch((emailError) => {
                console.error(
                  "Error during email sending process:",
                  emailError
                );
              });
          }
        })
        .catch((error) => {
          console.log("Error in CRIF authentication:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    selectPostIdentityMethod() {
      console.log("select successfully:");
      this.closeModal();

      this.$router.push({ name: "success", params: { guid: this.guid } });

      axios
        .post(process.env.VUE_APP_BACKEND_DOMAIN + "postIdenPdf.php", {
          guid: this.guid,
        })
        .then((response) => {
          console.log("PDF generated and sent successfully:", response);

          // Sending the confirmation email
          axios
            .post(
              process.env.VUE_APP_BACKEND_DOMAIN +
                "send-confirmation-email.php",
              new URLSearchParams({
                guid: this.guid,
                email: this.customerEmail,
              })
            )
            .then((emailResponse) => {
              if (emailResponse.data.status === "success") {
                console.log("Email sent successfully");
              } else {
                console.error(
                  "Error sending email:",
                  emailResponse.data.message
                );
              }
            })
            .catch((emailError) => {
              console.error("Error during email sending process:", emailError);
            });
        })
        .catch((error) => {
          console.error("Error generating and sending PDF:", error);
        });
    },
    async created() {
      console.log(`Trying to display disabled Preview Data for Step4.5`);
      console.log(toRaw(this.$store.state.persons));

      let p2 = toRaw(this.$store.state.persons[1]);
      if (p2?.firstName) {
        this.previewPerson2 = p2;
      } else {
        this.previewPerson2 = null;
      }

      this.loaded = true;
    },

    /* Opt-in-marketing  */
    submitMarketingOptIn() {
      console.log("checked");
      if (this.loadingMarketingOptIn) return;

      this.loadingMarketingOptIn = true;
      console.log(this.guid);
      axios
        .post(
          process.env.VUE_APP_BACKEND_DOMAIN + "marketing.php",
          {
            marketingOptIn: this.isMarketingOptedIn,
          },
          {
            headers: {
              Processid: this.guid,
            },
          }
        )
        .then((res) => {
          if (res.data && res.data.success) {
            this.loading = false;
          }
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

button {
  margin-top: 10px;
  padding: 10px;
  background-color: #ffb300;
  color: rgb(0, 0, 0);
  border: none;
  cursor: pointer;
  border-radius: 10px;
}

button:hover {
  background-color: #ffb300a1;
}
.btn:disabled {
  background-color: #e0e0e0;
  cursor: not-allowed;
}
/* Modal overlay background */
.modal-overlay {
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
}

/* Modal content style */
.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  width: 80%;
  max-width: 900px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.modal-title {
  margin-bottom: 20px;
}

.button-cards {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
  margin-bottom: 20px;
}

.custom-card {
  border: 2px solid black;
  background-color: white;
  padding: 15px;
  border-radius: 10px;
  flex: 1 1 45%;
  box-sizing: border-box;
  text-align: center;
  min-width: 270px;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.custom-btn {
  background-color: white;
  color: black;
  border: 2px solid black;
  padding: 10px 20px;
  width: 100%;
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  border-radius: 5px;
  transition: background-color 0.3s, color 0.3s;
}

.custom-btn:hover {
  background-color: black;
  color: white;
}

.custom-btn-close {
  background-color: #f44336;
  color: white;
  border: none;
  margin-top: 20px;
  width: auto;
}

.custom-btn strong {
  font-weight: bold;
}

.description {
  font-size: 14px;
  margin-top: 10px;
  color: #333;
  text-align: justify;
  margin-bottom: 0;
}
</style>
